import Rest from 'services/data/rest';

class EmailAddress extends Rest {
  static path = 'emailaddress';
}

export default EmailAddress;
